const messages = {
    pageTitle: 'Lista maszyn',
    menuTitle: 'Maszyny',

    common: {
        tooltips: {
            edit: 'Edycja',
            machineCost: 'Koszt maszyny',
            machineConfiguration: 'Konfiguracja wydajności i strat'
        },
        buttons: {
            save: 'Zapisz',
            cancel: 'Anuluj',
            add: 'Dodaj maszynę'
        },
        actions: 'Akcje',
        loading: 'Ładowanie',
        noData: 'Brak danych',
        noDataAvailable: 'Brak dostępnych działów',
        currency: 'zł'
    },

    filters: {
        search: 'Szukaj',
        departments: 'Działy',
        hideVirtual: 'Ukryj wirtualne'
    },

    table: {
        headers: {
            machineName: 'Nazwa maszyny',
            symbol: 'Symbol',
            numberOfAggregate: 'Liczba agregatów',
            department: 'Dział',
            canReportAccident: 'Zgłaszanie awarii',
            isVisible: 'Czy widoczna?',
            actions: 'Akcje'
        }
    },

    dialog: {
        titleNew: 'Nowa maszyna',
        titleEdit: 'Edycja maszyny'
    },

    manHourCostDialog: {
        title: 'Edycja roboczogodziny',
        fields: {
            manHourCost: 'Koszt roboczogodziny'
        },
        validation: {
            costRequired: 'Proszę podać koszt.',
            invalidFormat: 'Niepoprawny format.'
        }
    },

    machineCostDialog: {
        title: 'Koszty dla maszyny',
        noProcesses: 'Nie dodano procesów',
        table: {
            headers: {
                name: 'Nazwa',
                manHourCost: 'Koszt roboczogodziny (zł)',
                actions: 'Akcje'
            }
        }
    },

    configurationDialog: {
        tabs: {
            paper: 'Konfiguracja wydajności dla papierów',
            digitalSheet: 'Konfiguracja wydajności dla druku cyfrowego (arkusz)',
            digitalRoll: 'Konfiguracja wydajności dla druku z rolki',
            cuttingFromRoll: 'Konfiguracja wydajności cięcia z rolki',
            wastePercent: 'Straty procentowe',
            wasteAmount: 'Konfiguracja strat wartościowo',
            foldingWaste: 'Straty falcowania',
            colourWaste: 'Straty kolorów',
            billboardCollector: 'Konfiguracja wydajności zbierania',
            lamination: 'Wydajność foliowania',
            tinning: 'Konfiguracja wydajności dla listwowania',
            lithoLamination: 'Konfiguracja wydajności dla kaszerowania',
            punching: 'Konfiguracja wydajności dla panczowania',
            drilling: 'Konfiguracja wydajności dla wiercenia',
            calendarAssembly: 'Konfiguracja wydajności dla składania kalendarzy',
            stackDieCutting: 'Konfiguracja wydajności dla przepychania',
            spiral: 'Konfiguracja wydajności dla spiralowania'
        },
        fields: {
            wasteAmount: 'Straty wartościowo'
        },
        table: {
            headers: {
                paperGroup: 'Grupa papieru',
                weightBegin: 'Początek zakresu gramatury',
                weightEnd: 'Koniec zakresu gramatury',
                amountPerHour: 'Wydajność na godzinę',
                actions: 'Usuń'
            }
        },
        tableDigital: {
            headers: {
                coloursSideAMax: 'Maksymalna liczba kolorów strona A',
                coloursSideBMax: 'Maksymalna liczba kolorów strona B',
                coloursSideAMin: 'Minimalna liczba kolorów strona A',
                coloursSideBMin: 'Minimalna liczba kolorów strona B',
                amountPerHour: 'Wydajność na godzinę (sztuk)',
                metersPerMinutes: 'Wydajność na minutę (MB)',
                isEPM: 'Czy druk EPM?',
                isB1Format: 'Czy format B1?',
                actions: 'Usuń'
            }
        },
        tableFoldingWaste: {
            headers: {
                amountFrom: 'Od nakładu włącznie',
                amountTo: 'Do nakładu włącznie',
                wastePercent: 'Straty procentowe',
                wasteAmount: 'Makulatura stała',
                foldingType: 'Sposób falcowania'
            },
            noFoldingTypes: 'Brak sposobów falcowania przypisanych do maszyny'
        },
        tableWastePercent: {
            headers: {
                wastePercent: 'Straty procentowe',
                amountBegin: 'Początek zakresu nakładu',
                amountEnd: 'Koniec zakresu nakładu'
            }
        },
        tableColourWaste: {
            headers: {
                colourType: 'Typ koloru',
                wasteAmount: 'Makulatura stała'
            },
            noColourTypes: 'Brak typów kolorów',
            allColourTypesAssigned: 'Rozpisano wszystkie typy lakierów'
        },
        tableRoll: {
            none: 'brak',
            headers: {
                paper: 'Surowiec',
                makeReadyDuration: 'Czas przyrządu (min.)',
                metersPerMinute: 'Prędkość pracy (m/min.)',
                actions: 'Usuń'
            },
            validation: {
                paperDuplicate: 'Ten surowiec jest już wybrany w innej konfiguracji',
                makeReadyDurationRequired: 'Czas przyrządu jest wymagany',
                makeReadyDurationInteger: 'Wymagana liczba całkowita',
                makeReadyDurationMin: 'Wartość musi być większa od 0',
                metersPerMinuteRequired: 'Prędkość (m/min.) jest wymagana',
                metersPerMinuteInteger: 'Wymagana liczba całkowita',
                metersPerMinuteMin: 'Wartość musi być większa od 0'
            }
        },
        tableBillboardCollector: {
            makeReadyDuration: 'Czas przyrządu (min.)',
            efficiency: 'Wydajność na godzinę'
        },
        tableTinning: {
            makeReadyDuration: 'Czas przyrządu (min.)',
            efficiency: 'Wydajność na godzinę'
        },
        tableLithoLamination: {
            makeReadyDuration: 'Czas przyrządu (min.)',
            efficiency: 'Wydajność na godzinę'
        },
        tablePunching: {
            makeReadyDuration: 'Czas przyrządu (min.)',
            maxStackHeight: 'Maksymalna wysokość stosu (mm)',
            batchDuration: 'Czas jednego wsadu (min.)'
        },
        tableDrilling: {
            makeReadyDuration: 'Czas przyrządu (min.)',
            maxStackHeight: 'Maksymalna wysokość stosu (mm)',
            batchDuration: 'Czas jednego wsadu (min.)'
        },
        tableCalendarAssembly: {
            makeReadyDuration: 'Czas przyrządu (min.)',
            efficiency: 'Wydajność (szt./h)'
        },
        tableStackDieCutting: {
            makeReadyDuration: 'Czas przyrządu (min.)',
            maxStackHeight: 'Maksymalna wysokość wsadu (mm)',
            batchDuration: 'Czas wykonania jednego wsadu (min.)'
        },
        tableSpiral: {
            headers: {
                minNumberOfPages: 'Minimalna liczba stron włącznie',
                maxNumberOfPages: 'Maksymalna liczba stron włącznie',
                formatA: 'Format A (mm)',
                formatB: 'Format B (mm)',
                makeReadyDuration: 'Czas przyrządu (min.)',
                efficiency: 'Wydajność na godzinę',
                productTypeId: 'Produkt',
                actions: 'Usuń'
            }
        },
        tableLamination: {
            headers: {
                minPaperWeight: 'Gramatura od',
                maxPaperWeight: 'Gramatura do',
                efficiency: 'Wydajność na godzinę',
                makeReadyDuration: 'Czas przyrządu (min.)',
                productionProcess: 'Proces produkcyjny',
                actions: 'Usuń'
            }
        },
        actions: {
            addRow: 'Dodaj kolejną konfigurację',
            remove: 'Usuń'
        },
        noData: 'Brak danych. Dodaj konfigurację klikając przycisk poniżej.',
        emptyForMachine: 'Brak zdefiniowanych konfiguracji wydajności i strat dla maszyny',
        validation: {
            paperGroupRequired: 'Proszę wybrać grupę papieru.',
            wasteAmountRequired: 'Proszę podać straty wartościowo.',
            wasteAmountInteger: 'Proszę podać liczbę całkowitą.',
            wasteAmountMin: 'Wartość nie może być ujemna.',
            foldingWasteAmountFromRequired: 'Proszę podać wartość od nakładu.',
            foldingWasteAmountToRequired: 'Proszę podać wartość do nakładu.',
            foldingWasteAmountRange: 'Wartość od nakładu musi być mniejsza lub równa wartości do nakładu.',
            foldingWastePercentRequired: 'Proszę podać straty procentowe (min. 0,01).',
            foldingWasteAmountRequired: 'Proszę podać makulaturę stałą.',
            foldingWasteTypeRequired: 'Proszę wybrać sposób falcowania.',
            colourWasteTypeRequired: 'Proszę wybrać typ koloru.',
            colourWasteTypeDuplicate: 'Ten typ koloru jest już wybrany w innej konfiguracji.',
            colourWasteAmountRequired: 'Proszę podać makulaturę stałą.',
            wastePercentRequired: 'Proszę podać straty procentowe (min. 0,01).',
            wastePercentAmountBeginRequired: 'Proszę podać początek zakresu nakładu.',
            wastePercentAmountEndRequired: 'Proszę podać koniec zakresu nakładu.',
            billboardCollectorMakeReadyDurationRequired: 'Proszę podać czas przyrządu.',
            billboardCollectorMakeReadyDurationMin: 'Wartość nie może być ujemna.',
            billboardCollectorEfficiencyRequired: 'Proszę podać wydajność na godzinę.',
            billboardCollectorEfficiencyMin: 'Wydajność musi być większa od 0.',
            tinningMakeReadyDurationRequired: 'Proszę podać czas przyrządu.',
            tinningMakeReadyDurationInteger: 'Wymagana liczba całkowita.',
            tinningMakeReadyDurationMin: 'Wartość nie może być ujemna.',
            tinningEfficiencyRequired: 'Proszę podać wydajność na godzinę.',
            tinningEfficiencyInteger: 'Wymagana liczba całkowita.',
            tinningEfficiencyMin: 'Wydajność musi być większa od 0.',
            lithoLaminationMakeReadyDurationRequired: 'Proszę podać czas przyrządu.',
            lithoLaminationMakeReadyDurationInteger: 'Wymagana liczba całkowita.',
            lithoLaminationMakeReadyDurationMin: 'Wartość nie może być ujemna.',
            lithoLaminationEfficiencyRequired: 'Proszę podać wydajność na godzinę.',
            lithoLaminationEfficiencyInteger: 'Wymagana liczba całkowita.',
            lithoLaminationEfficiencyMin: 'Wydajność musi być większa od 0.',
            punchingMakeReadyDurationRequired: 'Proszę podać czas przyrządu.',
            punchingMakeReadyDurationInteger: 'Wymagana liczba całkowita.',
            punchingMakeReadyDurationMin: 'Wartość nie może być ujemna.',
            punchingMaxStackHeightRequired: 'Proszę podać maksymalną wysokość stosu.',
            punchingMaxStackHeightInteger: 'Wymagana liczba całkowita.',
            punchingMaxStackHeightMin: 'Maksymalna wysokość stosu musi być większa od 0.',
            punchingBatchDurationRequired: 'Proszę podać czas jednego wsadu.',
            punchingBatchDurationInteger: 'Wymagana liczba całkowita.',
            punchingBatchDurationMin: 'Czas jednego wsadu musi być większy od 0.',
            drillingMakeReadyDurationRequired: 'Proszę podać czas przyrządu.',
            drillingMakeReadyDurationInteger: 'Wymagana liczba całkowita.',
            drillingMakeReadyDurationMin: 'Wartość nie może być ujemna.',
            drillingMaxStackHeightRequired: 'Proszę podać maksymalną wysokość stosu.',
            drillingMaxStackHeightInteger: 'Wymagana liczba całkowita.',
            drillingMaxStackHeightMin: 'Maksymalna wysokość stosu musi być większa od 0.',
            drillingBatchDurationRequired: 'Proszę podać czas jednego wsadu.',
            drillingBatchDurationInteger: 'Wymagana liczba całkowita.',
            drillingBatchDurationMin: 'Czas jednego wsadu musi być większy od 0.',
            calendarAssemblyMakeReadyDurationRequired: 'Proszę podać czas przyrządu.',
            calendarAssemblyMakeReadyDurationInteger: 'Wymagana liczba całkowita.',
            calendarAssemblyMakeReadyDurationMin: 'Wartość nie może być ujemna.',
            calendarAssemblyEfficiencyRequired: 'Proszę podać wydajność.',
            calendarAssemblyEfficiencyInteger: 'Wymagana liczba całkowita.',
            calendarAssemblyEfficiencyMin: 'Wydajność musi być większa od 0.',
            stackDieCuttingMakeReadyDurationRequired: 'Proszę podać czas przyrządu.',
            stackDieCuttingMakeReadyDurationInteger: 'Wymagana liczba całkowita.',
            stackDieCuttingMakeReadyDurationMin: 'Wartość nie może być ujemna.',
            stackDieCuttingMaxStackHeightRequired: 'Proszę podać maksymalną wysokość wsadu.',
            stackDieCuttingMaxStackHeightInteger: 'Wymagana liczba całkowita.',
            stackDieCuttingMaxStackHeightMin: 'Maksymalna wysokość wsadu musi być większa od 0.',
            stackDieCuttingBatchDurationRequired: 'Proszę podać czas wykonania jednego wsadu.',
            stackDieCuttingBatchDurationInteger: 'Wymagana liczba całkowita.',
            stackDieCuttingBatchDurationMin: 'Czas wykonania jednego wsadu musi być większy od 0.',
            laminationMinPaperWeightRequired: 'Proszę podać gramaturę od.',
            laminationMinPaperWeightMin: 'Wartość nie może być ujemna.',
            laminationMaxPaperWeightRequired: 'Proszę podać gramaturę do.',
            laminationMaxPaperWeightMin: 'Wartość musi być większa od 0.',
            laminationEfficiencyRequired: 'Proszę podać wydajność.',
            laminationEfficiencyMin: 'Wartość nie może być ujemna.',
            laminationMakeReadyDurationRequired: 'Proszę podać czas przyrządu.',
            laminationMakeReadyDurationMin: 'Wartość nie może być ujemna.',
            laminationProductionProcessRequired: 'Proszę wybrać proces produkcyjny.',
            spiralMakeReadyDurationRequired: 'Proszę podać czas przyrządu.',
            spiralEfficiencyRequired: 'Proszę podać wydajność na godzinę.',
            spiralMinAndMaxPagesRequired: 'Minimalną i maksymalną liczbę stron należy podać razem.',
            spiralPagesMin: 'Wartość nie może być ujemna.',
            spiralPagesRange: 'Minimalna liczba stron musi być mniejsza lub równa maksymalnej liczbie stron.',
            spiralFormatAAndBRequired: 'Format A i format B należy podać razem.',
            spiralFormatMin: 'Wartość musi być większa od 0.'
        },
        notifications: {
            saved: 'Konfiguracja została zapisana.',
            savedDigitalRoll: 'Konfiguracja druku z rolki została zapisana.',
            savedCuttingFromRoll: 'Konfiguracja cięcia z rolki została zapisana.',
            savedBillboardCollector: 'Konfiguracja zbieraczki do billboardów została zapisana.',
            savedLamination: 'Konfiguracja wydajności foliowania została zapisana.',
            savedTinning: 'Konfiguracja wydajności listwowania została zapisana.',
            savedLithoLamination: 'Konfiguracja wydajności kaszerowania została zapisana.',
            savedPunching: 'Konfiguracja wydajności panczowania została zapisana.',
            savedDrilling: 'Konfiguracja wydajności wiercenia została zapisana.',
            savedCalendarAssembly: 'Konfiguracja wydajności składania kalendarzy została zapisana.',
            savedStackDieCutting: 'Konfiguracja wydajności przepychania została zapisana.',
            savedSpiral: 'Konfiguracja wydajności spiralowania została zapisana.'
        },
        errors: {
            fetchConfig: 'Nie udało się pobrać konfiguracji.',
            save: 'Zapis konfiguracji nie powiódł się.',
            fetchDigitalRollConfig: 'Nie udało się pobrać konfiguracji druku z rolki.',
            saveDigitalRollConfig: 'Zapis konfiguracji druku z rolki nie powiódł się.',
            fetchCuttingFromRollConfig: 'Nie udało się pobrać konfiguracji cięcia z rolki.',
            saveCuttingFromRollConfig: 'Zapis konfiguracji cięcia z rolki nie powiódł się.',
            fetchBillboardCollectorConfig: 'Nie udało się pobrać konfiguracji zbieraczki do billboardów.',
            saveBillboardCollectorConfig: 'Zapis konfiguracji zbieraczki do billboardów nie powiódł się.',
            fetchLaminationConfig: 'Nie udało się pobrać konfiguracji wydajności foliowania.',
            saveLaminationConfig: 'Zapis konfiguracji wydajności foliowania nie powiódł się.',
            fetchTinningConfig: 'Nie udało się pobrać konfiguracji wydajności listwowania.',
            saveTinningConfig: 'Zapis konfiguracji wydajności listwowania nie powiódł się.',
            fetchLithoLaminationConfig: 'Nie udało się pobrać konfiguracji wydajności kaszerowania.',
            saveLithoLaminationConfig: 'Zapis konfiguracji wydajności kaszerowania nie powiódł się.',
            fetchPunchingConfig: 'Nie udało się pobrać konfiguracji wydajności panczowania.',
            savePunchingConfig: 'Zapis konfiguracji wydajności panczowania nie powiódł się.',
            fetchDrillingConfig: 'Nie udało się pobrać konfiguracji wydajności wiercenia.',
            saveDrillingConfig: 'Zapis konfiguracji wydajności wiercenia nie powiódł się.',
            fetchCalendarAssemblyConfig: 'Nie udało się pobrać konfiguracji wydajności składania kalendarzy.',
            saveCalendarAssemblyConfig: 'Zapis konfiguracji wydajności składania kalendarzy nie powiódł się.',
            fetchStackDieCuttingConfig: 'Nie udało się pobrać konfiguracji wydajności przepychania.',
            saveStackDieCuttingConfig: 'Zapis konfiguracji wydajności przepychania nie powiódł się.',
            fetchSpiralConfig: 'Nie udało się pobrać konfiguracji wydajności spiralowania.',
            saveSpiralConfig: 'Zapis konfiguracji wydajności spiralowania nie powiódł się.'
        }
    },

    fields: {
        name: 'Nazwa',
        symbol: 'Symbol',
        code: 'Kod',
        mpk: 'MPK',
        mpkPlaceholder: 'MPK',
        numberOfWorkers: 'Liczba pracowników',
        department: 'Dział',
        subDepartment: 'Wydział',
        durGroup: 'Grupa DUR',
        productionProcesses: 'Procesy produkcyjne',
        productionProcessesPlaceholder: 'Wybierz procesy produkcyjne',
        printType: 'Rodzaj druku',
        printTypePlaceholder: 'Rodzaj druku',
        sheetFormat: 'Format arkusza',
        sheetFormatPlaceholder: 'Format arkusza',
        plateType: 'Rodzaj płyt',
        plateTypePlaceholder: 'Rodzaj płyt',
        hasVarnishingTower: 'Ma wieże lakierującą',
        canReportAccident: 'Zgłaszanie awarii',
        showInDashboard: 'Pokazuj na dashboard',
        isVisible: 'Czy widoczna?',
        isVirtual: 'Wirtualna'
    },

    placeholders: {
        noProcessFound: 'Nie znaleziono procesu',
        noData: 'Brak danych',
        department: 'Dział',
        unknownMachine: 'Nieznana maszyna'
    },

    validation: {
        nameRequired: 'Proszę podać nazwę maszyny.',
        symbolRequired: 'Proszę podać symbol maszyny.',
        departmentRequired: 'Proszę wybrać dział.',
        durGroupRequired: 'Proszę wybrać grupę DUR.',
        numberOfWorkersInteger: 'Proszę podać liczbę',
        numberOfWorkersRange: 'Proszę podać wartość z zakresu 1-{max}'
    },

    notifications: {
        created: 'Utworzono maszynę.',
        updated: 'Maszyna została zaktualizowana.',
        costSaved: 'Koszt roboczogodziny został zapisany.'
    },

    errors: {
        fetchList: 'Nie udało się pobrać listy maszyn.',
        fetchOne: 'Nie udało się pobrać danych maszyny.',
        save: 'Zapis maszyny nie powiódł się.',
        saveWasteAmount: 'Zapis strat wartościowo nie powiódł się.',
        fetchFoldingWasteConfig: 'Nie udało się pobrać konfiguracji strat falcowania.',
        saveFoldingWasteConfig: 'Zapis konfiguracji strat falcowania nie powiódł się.',
        fetchColourWasteConfig: 'Nie udało się pobrać konfiguracji strat kolorów.',
        saveColourWasteConfig: 'Zapis konfiguracji strat kolorów nie powiódł się.',
        fetchColourTypes: 'Nie udało się pobrać typów kolorów.',
        fetchWastePercentConfig: 'Nie udało się pobrać konfiguracji strat procentowych.',
        saveWastePercentConfig: 'Zapis konfiguracji strat procentowych nie powiódł się.',
        saveCost: 'Nie udało się zapisać kosztu.',
        fetchPrintTypes: 'Nie udało się pobrać rodzajów druku.',
        fetchSheetFormats: 'Nie udało się pobrać formatów arkuszy.',
        fetchPlateTypes: 'Nie udało się pobrać rodzajów płyt.',
        fetchDurGroups: 'Nie udało się pobrać grup DUR.',
        fetchCostCenterNumbers: 'Nie udało się pobrać MPK.',
        fetchProductionDepartments: 'Pobranie działów nie powiodło się.',
        fetchProcesses: 'Pobranie procesów nie powiodło się.',
        fetchProductTypes: 'Pobranie rodzajów produktów nie powiodło się.'
    }
}

export default {
    messages,
    locale: 'pl'
}
